import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditorContent as TiptapEditorContent, BubbleMenu as TiptapBubbleMenu, } from '@tiptap/react';
import { createTiptapEditorController } from './tiptapEditorController';
export function createTiptapEditor(init) {
    return {
        create(config) {
            const controller = createTiptapEditorController(config);
            return {
                controller,
                Component(props) {
                    const { as: { Toolbar: ToolbarView, SuggestionPopover }, suggestion, state: editor, } = props;
                    // Simplified: Controller handles all suggestion state management
                    // The provider just renders the editor UI
                    return (_jsxs("div", { style: { position: 'relative', width: '100%' }, children: [_jsx(TiptapEditorContent, { editor: editor, spellCheck: false, style: { width: '100%' } }), _jsx(TiptapBubbleMenu, { editor: editor, children: _jsx(ToolbarView, {}) })] }));
                },
            };
        },
    };
}
//# sourceMappingURL=tiptapEditorProvider.js.map